<template>
    <div class="partner-listing-wrapper">
        <div v-if="loading">
            <img class="d-none d-lg-block" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/partnerListingLoadingDesktop.svg" alt="Desktop">
            <img class="d-none d-md-block d-lg-none" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/partnerListingLoadingTablet.svg" alt="Tablet">
            <img class="d-block d-md-none" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/partnerListingLoadingMobile.svg" alt="Mobile">
        </div>
        <div v-if="!loading && partnerTypes && partnerTypes.length">
            <div v-for="(aPartnerType, index) in partnerTypes" :key="index">
                <div v-if="aPartnerType && aPartnerType.partners && aPartnerType.partners.length" class="mb-5">
                    <!-- <h3 v-if="aPartnerType.displayName" class="font-weight-bold mb-3 mt-4">
                        <span>{{ aPartnerType.displayName }}</span>
                    </h3> -->
                    <section
                        :id="'splide-' + randomId + '-' + index"
                        class="splide splide-partners px-0"
                        aria-label="partners logo slider"
                    >
                        <div class="splide__track mask-container">
                            <div class="splide__list d-flex align-items-stretch">
                                <div
                                    v-for="(aPartner, partnerIndex) in aPartnerType.partners"
                                    :key="partnerIndex"
                                    class="splide__slide partner-list-single-element-wrapper text-center my-2 d-flex"
                                >
                                    <div class="w-100">
                                        <div class="h-100 py-4 rounded-corners-10">
                                            <a v-if="aPartner && aPartner.slug" :href="'/partners/' + aPartner.slug" class="d-flex flex-column h-100">
                                                <img v-if="aPartner && aPartner.logo && aPartner.logo.xxx" :src="aPartner.logo.xxx" alt="" class="partner-box-shadow align-self-center rounded-corners-10 single-image-partner mb-3 p-2">
                                                <img v-else src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/Placeholder PARTNER LOGO image on png.svg" alt="" class="partner-box-shadow align-self-center rounded-corners-10 single-image-partner mb-3">
                                                <h3 v-if="aPartner && aPartner.name" class="font-weight-bold h5 m-0 pt-0 pt-md-3 text-dark font-size-mobile text-break text-center">{{ cutPartnerName(aPartner.name) }}</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core';
import { provideApolloClient, useQuery } from '@vue/apollo-composable';
import { watch } from 'vue';
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from '../../../services/concord_queries.js';

export default {
    name: 'partnersListing',
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            randomId: Math.random().toString(36).substring(2, 15),
            loading: true,
            partnerTypes: [],
            isDevMioActive: this.settingsPerm.isDevMioActive,
            isDevmioNlActive: this.settingsPerm.isDevmioNlActive,
            splideInstances: []
        };
    },
    methods: {
        fetchPartners(partnerTypeId, index) {
            const { onResult } = useQuery(CONCORD_QUERIES.GET_PARTNERS_BY_PARTENTERTYPEID, {
                partnerTypeId: partnerTypeId
            }
            );

            onResult(({ data }) => {
                if (data && data.platformPartners && data.platformPartners.PlatformPartners && data.platformPartners.PlatformPartners.length) {
                    this.partnerTypes[index].partners = data.platformPartners.PlatformPartners;
                    this.$nextTick(() => {
                        this.mountSplide(index);
                    });
                }
            });
        },

        cutPartnerName(name) {
            if (name && name.length > 30) {
                return name.substring(0, 30) + '...';
            } else {
                return name;
            }
        },

        mountSplide(index) {
            let thiz = this;
            let padding = {
                right: "0rem",
                left: "0rem",
            };

            setTimeout(function () {
                const splideId = `#splide-${thiz.randomId}-${index}`;
                const splideElement = document.querySelector(splideId);
                
                if (!splideElement) return;
                
                // Check if splide already exists for this index
                if (thiz.splideInstances[index]) {
                    thiz.splideInstances[index].refresh();
                    return;
                }

                if (thiz.partnerTypes[index]?.partners?.length > 3) {
                    padding = {
                        right: "0rem",
                        left: "0rem",
                    };
                }

                thiz.splideInstances[index] = new Splide(splideId, {
                    classes: {
                        arrows: 'splide__arrows arrows',
                        arrow: 'splide__arrow arrow',
                        prev: 'splide__arrow--prev prev',
                        next: 'splide__arrow--next next',
                    },
                    perPage: 5,
                    perMove: 1,
                    gap: '1rem',
                    rewind: false,
                    pagination: false,
                    padding: padding,
                    breakpoints: {
                        1600: { perPage: 4 },
                        1280: { perPage: 4 },
                        991: { perPage: 3 },
                        767: { 
                            perPage: 2,
                        },
                        575: {
                            perPage: 2,
                            arrows: false,
                            padding: { left: "0rem", right: "5rem" },
                            start: 0,
                        },
                        480: {
                            perPage: 2,
                            arrows: false,
                            padding: { left: "0rem", right: "5rem" },
                            start: 0,
                        },
                        320: { 
                            perPage: 1, 
                            arrows: false, 
                            padding: { left: "0rem", right: "3rem" }, 
                            start: 0 
                        }
                    },
                });

                thiz.splideInstances[index].mount();
            }, 500);
        }
    },
    created() {
        const cache = new InMemoryCache();
        const customHeaders = {
            platform: "web",
            App: this.isDevmioNlActive
            ? "devmionl"
            : this.isDevMioActive
            ? "devmio"
            : "entwickler"
        };
        const apolloClient = new ApolloClient({
            cache,
            uri: this.settingsPerm.concordBackendURL,
            headers: customHeaders,
        });
        provideApolloClient(apolloClient);

        // Fetch partner types
        const { result } = useQuery(CONCORD_QUERIES.GET_PARTNER_TYPES);
        watch(result, (value) => {
            if (value && value.platformPartnerTypes && value.platformPartnerTypes.PlatformPartnerTypes && value.platformPartnerTypes.PlatformPartnerTypes.length && value.platformPartnerTypes.PlatformPartnerTypes.length) {
                const partnerTypes = value.platformPartnerTypes.PlatformPartnerTypes;
                this.partnerTypes = partnerTypes.map((type) => ({
                    ...type
                }));

                // Fetch partners for each partner type only if the partner type has partners
                this.partnerTypes.forEach((type, index) => {
                    if (type && type.partners && type.partners.length) {
                        this.fetchPartners(type._id, index);
                    }
                });
            }
            this.loading = false;
        });
    }
};
</script>

<style scoped>
    .partner-box-shadow{
        box-shadow: 0px 4px 4px 0px #00000040;
    }
    .single-image-partner{
        max-height: 150px;
        height: 150px;
        width: auto;
    }
    
    /* Small devices (landscape phones, 544px and up) */
    @media (max-width: 767px) {
        .single-image-partner{
            max-height: 100px;
        }
        .font-size-mobile {
            font-size: 12px;
        }
    }
</style>
